import React, { useEffect, useState } from 'react'


import SearchIcon from '@mui/icons-material/Search'
import {
  Card,
  CollapseSearch,
  Row,
  Button,
  Span,
  Input
} from 'components'
import { useLoading, useModal, useException, useAuth, useFile } from 'hooks'
import { useForm } from 'react-hook-form'
import { IResponseTypes } from 'services/core/genericEntityGST'
import { IGetItensAnexadosByFilterResponse, SegurancaDoTrabalhoServices, Anexo } from 'services/GST/SegurancaDoTrabalho'
import { COLORS, SPACING, FORMAT } from 'utils'

import TableWorkSafety from './components/TableWorkSafety'

const TabWorkSafety: React.FC = () => {
  const { setLoading, setMsgErro } = useLoading()
  const { convertFileToBase64 } = useFile()
  const [uploadProgress, setUploadProgress] = useState(0); 

  const {
    watch,
    control,
    formState: { errors }
  } = useForm()
  const { showModal } = useModal()
  const { createCustomException, getException } = useException()
  const { user: { IdUsuario } } = useAuth()

  const searchGlobal = watch('searchGlobal')

  const [contracts, setContracts] = useState<IGetItensAnexadosByFilterResponse[]>([])

  interface addFileToAttachmentProps {
    file: File
    idAmrItemSegurancaContrato: number
  }

  const addFileToAttachment = async ({
    file,
    idAmrItemSegurancaContrato
  }: addFileToAttachmentProps) => {
    setLoading('loading')

    try {
      const fileBase64: any = await convertFileToBase64(file)

      setContracts((prevState) =>
        prevState?.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map((anexo) => ({
              ...anexo,
              ...(anexo.idAmrItemSegurancaContrato === idAmrItemSegurancaContrato && {
                base64: fileBase64,
                filename: file.name
              })
            }))
          }
        })
      )

      setLoading('idle')
    } catch (error) {
      // setLoading("error")
      setLoading('idle')
      setMsgErro('Não foi possível fazer o upload do arquivo')
    }
  }

  const removeFileFromAttachment = (idAmrItemSegurancaContrato: number): void => {
    setLoading('loading')

    try {
      setContracts((prevState) =>
        prevState.map((contrato) => {
          return {
            ...contrato,
            anexos: contrato.anexos?.map(({ base64, filename, ...anexo }) => {
              if (base64) {
                if (anexo.idAmrItemSegurancaContrato === idAmrItemSegurancaContrato) {
                  return {
                    ...anexo
                  }
                }

                return {
                  ...anexo,
                  base64,
                  filename
                }
              }

              return anexo
            })
          }
        })
      )

      setLoading('idle')
    } catch (error) {
      // setLoading("error")
    }
  }
  const base64Size = (base64String: string) => {
    const stringLength = base64String.length;
    const sizeInBytes = (stringLength * 3) / 4 - (base64String.endsWith('==') ? 2 : base64String.endsWith('=') ? 1 : 0);
    return sizeInBytes;
  };

  const handleSendAttachments = (contractID: number) => {
  
    setLoading('loading');
    
    const MAX_FILE_SIZE = 120 * 1024 * 1024; 

    
    const newAttachmentFiles = contracts
      .filter((contrato: IGetItensAnexadosByFilterResponse) => contrato.idContrato === contractID)
      ?.map((contrato: IGetItensAnexadosByFilterResponse) =>
        contrato.anexos
          .filter((anexo: Anexo) => anexo.filename)
          ?.map((anexo: Anexo) => ({
            arquivo: anexo.base64,
            idAmrItemSegurancaContrato: anexo.idAmrItemSegurancaContrato,
            idContrato: contrato.idContrato,
            nmArquivo: anexo.filename,
          }))
      )
      .flat();
      let fileSizeBiggerThanMax=false;
      newAttachmentFiles.forEach(x=>{
        if(base64Size(x.arquivo)>MAX_FILE_SIZE){
          showModal({
            hideButtonCancel: true,
            message: 'Você está tentando anexar um arquivo com tamanho maior do que o permitido. Limite máximo: 120MB',
            txtButtonConfirm: 'OK',
            type: 'error',
          });
          fileSizeBiggerThanMax=true;
          setLoading('idle');

          return;
        }
      })
        if(fileSizeBiggerThanMax)return;
      console.log(newAttachmentFiles)
    SegurancaDoTrabalhoServices()
      .inserirDocumentoItem(newAttachmentFiles, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted); 
          showModal({
            hideButtonCancel: true,
            message: (
              <div>
                <p>Aguarde um momento, estamos anexando os arquivos...</p>
                <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '4px' }}>
                  <div
                    style={{
                      width: `${percentCompleted}%`,
                      height: '10px',
                      backgroundColor: '#3b82f6',
                      borderRadius: '4px',
                      transition: 'width 0.3s',
                    }}
                  />
                </div>
                <p>{percentCompleted}%</p>
              </div>
            ),
            txtButtonConfirm: 'OK',
          });
        },
      })
      .then((response) => {
        setLoading('idle');
  
       
        showModal({
          hideButtonCancel: true,
          message: 'Os documentos foram enviados com sucesso!',
          txtButtonConfirm: 'OK',
          type: 'success',
        });
  
        getContracts();
      })
      .catch((err: Error) => {
        setLoading('idle');
        const error = getException(err);
  
       
        showModal({
          hideButtonCancel: true,
          message: error.mensagem || 'Não foi possível enviar os arquivos',
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error',
        });
      });
  };

  const filterTable = (): IGetItensAnexadosByFilterResponse[] => {
    if (!searchGlobal) {
      return contracts
    }

    return contracts.filter(
      (contract: IGetItensAnexadosByFilterResponse) =>
        contract.nmFornecedor
          .toLowerCase()
          .includes(searchGlobal.toLowerCase()) ||
        contract.cdContrato.toLowerCase().includes(searchGlobal.toLowerCase()) ||
        contract.txObjetoContrato.toLowerCase().includes(searchGlobal.toLowerCase())
    )
  }

  const getContracts = () => {
    setLoading('loading')

    SegurancaDoTrabalhoServices()
      .getItensAnexadosByFilter({
        idUsuario: IdUsuario,
        txPesquisaGeral: searchGlobal,
      })
      .then(response => {
        if (response.status !== 200) {
          const { tipo, detalhe, mensagem } = response.data

          createCustomException({
            detalhe,
            mensagem,
            tipo: IResponseTypes[tipo],
          })
        }

        setContracts(response.data.entity)
        setLoading('idle')
      })
      .catch((err: Error) => {
        setLoading('idle')
        const error = getException(err)

        showModal({
          hideButtonCancel: true,
          message: error.mensagem,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error',
        })
      })
  }

  useEffect(() => {
    getContracts()
  }, [])

  return (
    <>
      {contracts && (
        <>
          <Card
            marginLeft={SPACING.spacing100}
            marginRight={SPACING.spacing15}
            marginBottom={SPACING.spacing100}
            padding={SPACING.spacing20}
            boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
            backgroundColor={COLORS.white}
            borderRadius={`0px 10px 0px 0px`}
            style={{
              left: '15px',
              paddingBottom: '5rem',
              position: 'absolute',
              right: '15px'
            }}
          >
            <Row
              alignItems="center"
              justifyContent="end"
              marginBottom={SPACING.spacing50}
              marginTop={SPACING.spacing20}
            >
              <Input
                control={control}
                errors={errors}
                formValue="searchGlobal"
                label="Pesquisa Geral"
                placeholder="Pesquisa"
                inputIcon={<SearchIcon style={{ cursor: 'default' }} />}
              />
            </Row>
            <>
              {contracts?.length === 0 && (
                <Row
                  alignItems="center"
                  justifyContent="center"
                  marginBottom={SPACING.spacing50}
                  marginTop={SPACING.spacing20}
                >
                  <Span
                    text="Não há documentos pendentes na competência atual"
                    fontSize="1rem"
                    fontWeight="bold"
                    color={COLORS.info}
                  />
                </Row>
              )}
              {filterTable()?.map((row: IGetItensAnexadosByFilterResponse) => (
                <CollapseSearch
                  key={row?.idContrato}
                  data={{
                    code: row?.cdContrato,
                    dataFim: FORMAT.formatDDMMYYYY(row?.dtFimVigencia),
                    dataIni: FORMAT.formatDDMMYYYY(row?.dtInicioVigencia),
                    empresa: row?.nmFornecedor,
                    titleCollapse: row?.txObjetoContrato
                  }}
                  hideButton
                >
                  <TableWorkSafety
                    tableData={row?.anexos}
                    handleDeleteDocument={removeFileFromAttachment}
                    handleUploadFile={addFileToAttachment}
                  />
                  <Row
                    justifyContent="flex-end"
                    alignItems="center"
                    marginTop={SPACING.spacing20}
                  >
                    <Button
                      onClick={() => handleSendAttachments(row.idContrato)}
                      disabled={!row?.anexos || row?.anexos?.length === 0}
                      text="ENVIAR"
                    />
                  </Row>
                </CollapseSearch>
              ))}
            </>
          </Card>
        </>
      )}
    </>
  )
}

export default TabWorkSafety
